import React, { FC } from 'react'
import toggles from 'feature-toggles'
import { WithTip } from 'components/tooltip/with-tip'
import { AppcuesIcon } from 'images/icons/header/'
import { Svg_s } from 'styles/app-styles'

const AppcuesWidget: FC = () => {
  
  if(toggles.displayAppCues()) {
    const widget = window.AppcuesWidget(window.Appcues.user());
    widget.init("#appcuesWidget", {
      position: "center",
      header: "<h1>Walkthroughs</h1>"
    });

    return (
      <WithTip position="bottom">
        <span>Show Walkthroughs</span>
        <a id="appcuesWidget">
          <div className="appcues-widget-icon appcues-icon appcues-icon-bell appcues-in appcues-slide">
            <Svg_s src={AppcuesIcon} id="appcuesIcon" />
          </div>
        </a>
      </WithTip>
    )
  } else return (
    <a id="appcuesWidget">
    </a>
  )
  
}

export default AppcuesWidget